import React from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Row, Col, Form, Input, Button, message } from 'antd';
import { PhoneOutlined, MailOutlined, EnvironmentOutlined } from '@ant-design/icons';
import '../css/ContactUs.css';

const ContactUS = () => {
    const [form] = Form.useForm();

    const siteUrl = 'https://www.tangwell.com.tw';
    const jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'LocalBusiness',
        name: '湯武生技',
        url: siteUrl,
        telephone: '+886-4-7977288',
        email: 'tangwell@tangwell.com.tw',
        address: {
            '@type': 'PostalAddress',
            streetAddress: '彰化縣伸港鄉溪底村工東一路36、38號',
            addressLocality: '伸港鄉',
            addressRegion: '彰化縣',
            addressCountry: 'TW'
        },
        contactPoint: [
            {
                '@type': 'ContactPoint',
                telephone: '+886-4-7977288',
                contactType: 'customer service',
                email: 'tangwell@tangwell.com.tw',
                areaServed: 'TW',
                availableLanguage: ['Chinese', 'English']
            }
        ],
        sameAs: [
            'https://www.facebook.com/your-page',
            'https://www.instagram.com/your-page',
            'https://www.youtube.com/your-channel'
        ],
        description: '立即聯繫湯武生技，洽詢餐飲食品原料訂購、合作與客製化解決方案。'
    };

    const onFinish = async (values) => {
        const hide = message.loading('傳送中...', 0);
        try {
            const response = await fetch('https://59.126.242.4:8114/api/contact', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(values),
            });

            if (response.ok) {
                hide();
                message.success('訊息已成功送出');
                form.resetFields();
            } else {
                throw new Error();
            }
        } catch (error) {
            hide();
            message.error('連線伺服器失敗，請檢查主機狀態');
        }
    };

    // 沿用與 Header 相同的判斷邏輯 (中英文切換)
    const location = useLocation();
    const isEnglish = location.pathname.startsWith('/en');

    return (
        <div className="contact-page">
            <Helmet>
                <title>聯絡我們</title>
                <meta name="description" content="立即聯繫湯武生技，洽詢餐飲食品原料訂購、合作與客製化解決方案。" />
                <meta name="keywords" content="聯絡我們, 合作洽詢" />
                <script type="application/ld+json">
                    {JSON.stringify(jsonLd)}
                </script>
            </Helmet>
            {/* 頂部 Banner */}
            <div className="contact-banner">
                <div className="banner-content">
                    {isEnglish ? (
                        <>
                            <div className="big-title-en">Contact Us</div>
                        </>
                    ) : (
                        <>
                            <div className="title-en">Contact Us</div>
                            <h1 className="big-title-ch">聯絡我們</h1>
                        </>
                    )}
                </div>
            </div>

            <div className="container-narrow">
                {/* 頂部三張資訊卡片 */}
                <div className="info-cards-wrapper">
                    <Row gutter={[24, 24]} justify="center">
                        <Col xs={24} md={8}>
                            <div className="contact-info-card">
                                <PhoneOutlined className="info-icon" />
                                <div className="title-en mb-5" style={{ fontWeight: 'bold' }}>Phone Number</div>
                                {isEnglish ? (
                                    <>
                                        <div className="content-en">Factory +886-4-7977288</div>
                                        <div className="content-en">Admin +886-4-7270089</div>
                                    </>
                                ) : (
                                    <>
                                            <div className="content-ch mb-5">工廠部 +886-4-7977288</div>
                                            <div className="content-ch">管理部 +886-4-7270089</div>
                                    </>
                                )}
                                
                            </div>
                        </Col>
                        <Col xs={24} md={8}>
                            <div className="contact-info-card">
                                <MailOutlined className="info-icon" />
                                <div className="title-en mb-5" style={{ fontWeight: 'bold' }}>Email</div>
                                {isEnglish ? (
                                    <>
                                        <div className="content-en mb-5">tangwell@tangwell.com.tw</div>
                                        <div className="content-en">tangwell.tw@gmail.com</div>
                                    </>
                                ) : (
                                    <>
                                            <div className="content-ch mb-5">tangwell@tangwell.com.tw</div>
                                            <div className="content-ch">tangwell.tw@gmail.com</div>
                                    </>
                                )}
                                
                            </div>
                        </Col>
                        <Col xs={24} md={8}>
                            <div className="contact-info-card">
                                <EnvironmentOutlined className="info-icon" />
                                <div className="title-en mb-5" style={{ fontWeight: 'bold' }}>Location</div>
                                {isEnglish ? (
                                    <>
                                        <div className="content-en mb-5" style={{ fontSize: '14px' }}>
                                            No. 398, Ziqiang Rd., Changhua City, Changhua County 500026, Taiwan (R.O.C.)
                                        </div>
                                        <div className="content-en" style={{ fontSize: '14px' }}>
                                            No. 36,38, Gongdong 1st Rd., Shengang Township, Changhua County 509004, Taiwan (R.O.C.)
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="content-ch mb-5">
                                            彰化市自強路398號
                                        </div>
                                        <div className="content-ch">
                                            彰化縣伸港鄉溪底村工東一路36、38號
                                        </div>
                                    </>
                                )}
                            </div>
                        </Col>
                    </Row>
                </div>

                {/* 聯絡表單區塊 */}
                <div className="contact-form-section">
                    <div className="form-intro">
                        <div className="content-ch mb-5">如果您對我們的產品有任何需求、合作意向，或需要專業的餐飲原物料解決方案，歡迎隨時與我們聯繫。湯武生技的專業團隊將竭誠為您服務，協助您掌握市場先機。</div>
                        <div className="content-en"> If you have any product inquiries, partnership proposals, or need professional catering ingredient solutions, please feel free to reach out. The Tang Wu Biotech team is ready to assist you in capturing market opportunities.</div>
                    </div>

                    <Form form={form} layout="vertical" onFinish={onFinish} className="main-form">
                        <Form.Item
                            label={
                                <div>
                                    <span className="content-ch">姓名</span>
                                    <span className="content-en ml-10">Name</span>
                                </div>
                            }
                            name="name"
                            rules={[{ required: true, message: 'Please enter your name' }]}
                        >
                            <Input placeholder="Your Name" />
                        </Form.Item>

                        <Form.Item
                            label={
                                <div>
                                    <span className="content-ch">信箱</span>
                                    <span className="content-en ml-10">Email</span>
                                </div>
                            }
                            name="email"
                            rules={[{ required: true, type: 'email', message: 'Please enter a valid email address' }]}
                        >
                            <Input placeholder="Your Email" />
                        </Form.Item>

                        <Form.Item
                            label={
                                <div>
                                    <span className="content-ch">主旨</span>
                                    <span className="content-en ml-10">Subject</span>
                                </div>
                            }
                            name="subject"
                            rules={[{ required: true, message: 'Please enter the subject' }]}
                        >
                            <Input placeholder="Subject" />
                        </Form.Item>

                        <Form.Item
                            label={
                                <div>
                                    <span className="content-ch">內容留言</span>
                                    <span className="content-en ml-10">Message</span>
                                </div>
                            }
                            name="message"
                            rules={[{ required: true, message: 'Please enter your message' }]}
                        >
                            <Input.TextArea rows={6} placeholder="How can we help you?" />
                        </Form.Item>

                        <Button htmlType="submit" className="submit-btn">
                            <div className="btn-font">Submit</div>
                        </Button>
                    </Form>
                </div>

                {/* Google Map 區塊 */}
                <div className="map-section">
                    <iframe
                        title="Location Map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3640.1989398135543!2d120.5093442745765!3d24.16475487274438!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3469406438d161c1%3A0xb62e76218194fba2!2zNTA55b2w5YyW57ij5Ly45riv6YSJ5bel5p2x5LiA6LevMzbomZ8!5e0!3m2!1szh-TW!2stw!4v1769242010964!5m2!1szh-TW!2stw"
                        width="100%"
                        height="500"
                        style={{ border: 0, borderRadius: '8px' }}
                        allowFullScreen=""
                        loading="lazy"
                    ></iframe>
                </div>
            </div>
        </div>
    );
};

export default ContactUS;